var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "back"
  }, [_c('Button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v($t("oxvu2", "返回"))])], 1), _c('Structure')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };